import React from 'react';
import { connect } from 'react-redux';
import { Modal, QueryParams } from '../../';
import style from './style.module.scss';
import { RecipeSection, ProductSection, NavigationSection } from '../';
import { TOGGLE_SINGLE_PRODUCT, TOGGLE_SINGLE_EVENT } from '../../../state/constants';

const SingleProduct = (props) => {
    const { dispatch } = props;
    console.log("SingleProduct props: ", props);
    return (
        <Modal onDismiss={() => dispatch({ type: TOGGLE_SINGLE_EVENT, bool: false })}>
            <div className={style.wrapper}>
                <NavigationSection />
                <ProductSection />
                <RecipeSection />
            </div>
        </Modal>
    );
};

SingleProduct.propTypes = {

};

export default connect()(QueryParams(SingleProduct));